export default "__VITE_ASSET__t7wX3in1__"